export default __webpack_public_path__ + "static/media/pillarofinfernalflame1.ff4ce736.png";